import styled from "@emotion/styled";
import { colors } from "styles/colors";
import { fonts } from "styles/fonts";

export const MetaWrap = styled.div`
  color: ${colors.GREY};

  @media (min-width: 769px) {
    margin: 0;
  }
  a {
    text-decoration: none;
    color: inherit;
  }
  > div {
    display: inline-block;
    position: relative;
    color: inherit;
    line-height: 1;

    ${(p) =>
      p.work_place &&
      `
    &:after {
      content: ',';
      align-self: flex-end;
      margin-left: 0;
      color: ${colors.GREY};
    }
    `};

    &:before {
      content: "";
      display: block;
      bottom: 0;
      left: 0;
      right: 5px;
      position: absolute;
      background-color: ${colors.GREY_DARK};
      transition: opacity 0.3s ease 0s;
    }
  }

  > div + div {
    margin-left: 6px;
  }

  > div:last-of-type {
    &:before {
      right: 0;
    }
    &:after {
      display: none;
    }
  }
`;
export const MetaAuthor = styled.div`
  color: ${colors.GREY_DARK} !important;
  margin-left: 2px;
  a {
    color: inherit;
  }
  &:before {
    height: 1px;
  }
  @media (max-width: 769px) {
    max-width: 240px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const MetaCategory = styled.div``;
export const MetaLocation = styled.div``;
export const MetaEdited = styled.div`
  color: ${colors.BLUE_LINK} !important;
  background-color: ${colors.EDITED_BACKGROUND};
  font-family: ${fonts.latoBold};
  font-size: 12px;
`;
